<div class="container-about">
    <div class="titulo">
        <h1>Sobre mi</h1>
    </div>
    <div class="container">
        <div class="image-me">
            <img src="assets/images/Brayan Taday.png" alt="Brayan">
        </div>
        <div class="sobre-mi">
            <p>Soy un Programador Junior, entusiasmado de aprender nuevas tecnologias para el desarrollo de aplicaciones y poder crecer profesionalmente, actualmente cursando el ultimo año de la carrera de Ciencias de la Computacion en la Universidad Politecnica Salesiana, soy una persona responsable, puntual, respetuosa, con buenos valores, siempre cooperando y a la vez ayudando a los demas.
            </p>
        </div>
    </div>
</div>
